import { AxiosRequestConfig } from "axios";
import axios from "http/customAxios"
import dayjs from "dayjs";

import { parseString } from "xml2js";

type CustomDataPropertyARIType = {
  [key: string]: {
    ticker: string;
    name: string;
    price: number;
    averageRate: number;
    originalRate: number;
    rackRate: number;
    cityTax: number;
  };
};

type ItemResultJsonType = {
  type: string
  expectedValue?: number
  givenValue?: number
  value?: string
}

type ResultJsonType = {
  [key: string]: {
    gha: {
      discrepancies: ItemResultJsonType[],
    },
    tripadvisor: {
      discrepancies: ItemResultJsonType[],
    },
    trivago: {
      discrepancies: ItemResultJsonType[],
    },
  },
}

type InitialResultJsonType = {
  propertyTicker: string,
  results : ResultJsonType
}

const config: AxiosRequestConfig = {
  method: "post",
  headers: {
    "Content-Type": "application/xml",
  },
};


export const getDataGoogle = (URLGoogle: string, body: string) => {
  try {
    return axios({ ...config, url: URLGoogle, data: body });
  } catch (error) {
    console.info("Error al buscar la data de Google", error);
  }
};

const calcPriceGoogle = (RoomBundle: any) => {
  return (
    Math.round(
      (Number(RoomBundle.Baserate[0]["_"]) +
        Number(RoomBundle.Tax[0]["_"]) +
        Number.EPSILON) *
        100
    ) / 100
  );
};

const priceIsWrong = (
  ARIprice: number,
  GooglePrice: number,
  tolerance: number
) => (Math.abs(ARIprice - GooglePrice) > tolerance ? true : false);

export const googleCompareToARI = async (
  URL_GOOGLE: string,
  BODY_GOOGLE: string,
  customPropertyARI: CustomDataPropertyARIType,
  tolerance: number,
  initialResultJson: InitialResultJsonType,
  nameHasDiscrepancies: string[],
  setNameHasDiscrepancies: Function
) => {
  const res = await getDataGoogle(URL_GOOGLE, BODY_GOOGLE);
  const xml = res?.data;
  parseString(xml,(err, result) => {
    if (result.Transaction.Result && result.Transaction.Result[0]) {
      result.Transaction.Result[0]?.RoomBundle?.forEach((RoomBundle: any) => {
        const indexPropertyARI = `${RoomBundle.RoomID}_${RoomBundle.PackageID}`;
        if (customPropertyARI[indexPropertyARI]) {
          const totalPriceGoogle = calcPriceGoogle(RoomBundle);
          if (
            priceIsWrong(
              customPropertyARI[indexPropertyARI].price,
              totalPriceGoogle,
              tolerance
            )
          ) {
            setNameHasDiscrepancies((prevValue: string[]) => [...prevValue, "google"])

            initialResultJson.results[
              indexPropertyARI
            ].gha.discrepancies.push({
              type: "PRICE",
              expectedValue: customPropertyARI[indexPropertyARI].price,
              givenValue: totalPriceGoogle,
            });
          }
        } else {
          initialResultJson.results[indexPropertyARI].gha.discrepancies.push(
            {
              type: "PROPERTYARI_NOT_FOUND",
              value: indexPropertyARI,
            }
          );
        }
      });
    } else {
      initialResultJson.results["not_records"].gha.discrepancies.push({
        type: "EMPTY",
        value: "Has no records",
      });
    }
  });
  return res
};

export const runGHA = async ({ config, customPropertyARI, tolerance, initialResultJson, nameHasDiscrepancies, setNameHasDiscrepancies, urlGoogle }: any) => {
  const date1 = dayjs(config.start);
    const date2 = dayjs(config.end);
    const BODY_GOOGLE = `<?xml version="1.0" encoding="UTF-8"?>
  <Query>
      <Checkin>${config.start}</Checkin>
      <Nights>${date2.diff(date1, "day")}</Nights>
      <Context>
      <UserCountry>${config.countryCode}</UserCountry>
      </Context>
      <PropertyList>
          <Property>${config.propertyTicker}</Property>
      </PropertyList>
  </Query>
  `;
  let runResGHA 
  try {
    runResGHA = await googleCompareToARI(
      urlGoogle,
      BODY_GOOGLE,
      customPropertyARI,
      tolerance,
      initialResultJson,
      nameHasDiscrepancies,
      setNameHasDiscrepancies
    );
  } catch (error) {
    runResGHA = "ocurrio un error"
  }
    
    return {
      runBodyGHA: BODY_GOOGLE,
      runResGHA
    }
}